const SEGMENT_WRITE_KEY = import.meta.env.VITE_APP_SEGMENT_FRONTEND_WRITE_KEY;
const ONESIGNAL_APP_ID = import.meta.env.VITE_APP_ONESIGNAL_APP_ID;
const ONESIGNAL_IS_ACTIVE = import.meta.env.MODE !== 'development';

export { SEGMENT_WRITE_KEY, ONESIGNAL_APP_ID, ONESIGNAL_IS_ACTIVE };
